import { FC, ReactNode, useState } from "react";
import { PlayerDto } from "../../../types/player";
import { NavigationButton, NavigationPlayer, NavigationPlayerName, NavigationPlayerPhoto } from "./styled";

interface PlayerNavigationButtonProps {
    direction: 'prev' | 'next';
    playerData: Partial<PlayerDto>;
    icon?: ReactNode;
}

export const PlayerNavigationButton: FC<PlayerNavigationButtonProps> = ({
    direction,
    playerData,
    icon,
}) => {
    const [show, setShow] = useState(false);

    if (!playerData?.url) {
        return null;
    }

    return (
        <a
            onMouseOver={() => setShow(true)}
            onMouseOut={() => setShow(false)}
            href={playerData?.url}
            key={playerData?.id}
            className="cursor-pointer opacity-40 hover:opacity-100 transition-all duration-200 text-white"
        >
            <div className="hidden sm:block">
                {icon}
                <NavigationPlayer $direction={direction} $show={show}>
                    <NavigationPlayerPhoto src={playerData?.photo} className="transition-all active:scale-95" />
                    <NavigationPlayerName>
                        {playerData?.number || ''} {playerData?.name}
                    </NavigationPlayerName>
                </NavigationPlayer>
            </div>
            <div className="sm:hidden">
                <NavigationPlayerPhoto src={playerData?.photo} />
            </div>
        </a>
    );
}